import { useState, useEffect } from 'react';
import { getRelayerStatus, isRelayerConfigured, type RelayerStatus } from '../services/relayer';

export function RelayerBanner() {
  const [status, setStatus] = useState<RelayerStatus | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!isRelayerConfigured()) {
      setError('Relayer not configured');
      return;
    }

    const checkStatus = async () => {
      const result = await getRelayerStatus();
      if (result) {
        setStatus(result);
        setError(null);
      } else {
        setError('Unable to connect to relayer');
      }
    };

    checkStatus();

    // Check every 30 seconds
    const interval = setInterval(checkStatus, 30000);
    return () => clearInterval(interval);
  }, []);

  if (!isRelayerConfigured()) {
    return (
      <div className="message message-warning" style={{ marginBottom: 'var(--space-lg)' }}>
        <strong>Relayer not configured.</strong> Set VITE_RELAYER_URL to enable gasless transactions.
      </div>
    );
  }

  if (error) {
    return (
      <div className="message message-error" style={{ marginBottom: 'var(--space-lg)' }}>
        <strong>Relayer offline.</strong> {error}
      </div>
    );
  }

  if (status?.lowBalance) {
    return (
      <div className="message message-warning" style={{ marginBottom: 'var(--space-lg)' }}>
        <strong>Low relayer balance!</strong> The relayer has {status.balanceEth} ETH remaining.
        Transactions may fail if not funded soon.
        <p style={{ fontSize: '0.75rem', marginTop: 'var(--space-xs)', fontFamily: 'monospace' }}>
          Relayer address: {status.address}
        </p>
      </div>
    );
  }

  return null;
}
